import {
  commonUrl,
  postRequest,
  ResponseDI,
} from "../../../base/services/urlService";
import { Id } from "../types";

interface ApproveLessonResponseResultDI {}

export const approveLesson = async (id: number) => {
  const response = await postRequest<
    any,
    ResponseDI<ApproveLessonResponseResultDI>
  >(`${commonUrl}/api/lesson/approveLesson?id=${id}`, {});
  return response.result;
};
